<div class="sl-registration-container">
    <mat-card appearance="outlined" class="sl-registration-content">
        <mat-card-header>
            <mat-card-title>{{ 'GeneralMeetingRegistrationPrint.Title' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            @if (isLoading()) {
                <mat-spinner [diameter]="32" />
            } @else {
                <!--
                ################################################################################################
                TODO: ng-container TEMPORARY HACK - WILL BE REMOVED IN 4 WEEKS
                OBS: If it's pass May, 1st 2026 and this is still here, just remember, we meant well
                ################################################################################################
                -->
                @if (!isMS) {
                    <p>{{ 'GeneralMeetingRegistrationPrint.Description' | translate }}</p>
                }
                <button mat-stroked-button (click)="print()">
                    <mat-icon>print</mat-icon>
                    {{ 'General.Print' | translate }}
                </button>
            }
            <a mat-stroked-button routerLink="/">
                <mat-icon>arrow_back</mat-icon>
                {{ 'General.Previous' | translate }}
            </a>
        </mat-card-content>
    </mat-card>
</div>

@if (!isLoading()) {
    <div class="sl-registration-print-section">
        @let instructionsObj = instructions()!;
        <div>
            <div style="width: 100%; height: 50px">
                <div style="float: left; margin-right: 20px">
                    <img style="height: 50px" [src]="tenantLogo()" />
                </div>
                <div style="float: right">
                    <h2 style="margin: 0">{{ currentMeeting()?.companyName }}</h2>
                </div>
                <div style="float: right; clear: right; text-align: right">
                    <div>{{ currentMeeting()?.place }}</div>
                    <div>{{ $safeNavigationMigration(currentMeeting()?.startDateTime) | localizedDate: 'longCustom' }}</div>
                    <div>
                        <span>{{ currentShareholderData()?.displayName }}&nbsp;</span>
                        <span>({{ 'Shareholders.Votes' | translate }}: {{ currentShareholderData()?.votes }})</span>
                    </div>
                </div>
            </div>
            @if (!shouldNetvoteUseWordingForCooperatives()) {
                <div>
                    <h1 style="text-align: center; clear: both">
                        @if (currentMeeting()?.isOrdinary) {
                            {{ 'GeneralMeeting.OrdinaryAnnualMeeting' | translate }}
                        } @else {
                            {{ 'GeneralMeeting.ExtraordinaryGeneralMeeting' | translate }}
                        }
                    </h1>
                </div>
            }
        </div>
        <h2>
            {{ 'AgendaItems.Instructions' | translate }}
        </h2>
        <table>
            <tr>
                <th>{{ 'General.NumberAbbr' | translate }}</th>
                <th>{{ 'AgendaItems.Agenda' | translate }}</th>
                <th>{{ 'LiveVoting.YourVote' | translate }}</th>
            </tr>
            @for (item of instructionsObj.instructions; track item.gmAgendaItemNumber; let i = $index) {
                @if (!item.parentGmAgendaItemNumber) {
                    <tr class="topic-spacer"></tr>
                }
                @if (
                    !!item?.parentGmAgendaItemNumber
                    && item.parentGmAgendaItemNumber !== instructionsObj.instructions[i - 1].parentGmAgendaItemNumber
                ) {
                    <tr class="first-child-spacer"></tr>
                }
                <tr>
                    <td [style.vertical-align]="'top'">
                        <span [class.child-item]="!!item.parentGmAgendaItemNumber">
                            {{ item.number }}
                        </span>
                    </td>
                    <td [style.vertical-align]="'top'">
                        {{ item.description }}
                    </td>
                    <td [style.vertical-align]="'top'" [style.width.px]="120">
                        {{ item.voteDescription }}
                    </td>
                </tr>
            }
        </table>
        @if (hasPresetInstructions()) {
            <h2>
                {{ 'AgendaItems.AdditionalProposalsAmendments' | translate }}
            </h2>
            <p>
                {{ instructionsText() }}
                <br />
                <br />
                <b>{{ 'AgendaItems.AdditionalProposalsAmendmentsField' | translate }}:</b>
                {{ instructionsObj.instructionAgendaItemChangeDescription }}
                @if (currentMeeting()?.splitInstructions) {
                    <br />
                    <b>{{ 'AgendaItems.NewItems' | translate }}:</b>
                    {{ instructionsObj.instructionNewAgendaItemDescription }}
                }
            </p>
        }
    </div>
}
